<template>
  <draggable
    :list="[filter]"
    :group="{ name: 'query', pull: 'clone', put: true }"
    :sort="false"
    @start="draggedFilter(filter)"
    @change="droppedFilter(filter)"
  >
    <div
      :id="'filter-subcategory-item-' + filter._id"
      class="filter-subcategory-item"
      :class="{ selected: filtersToExport.includes(filter._id) }"
    >
      <b-row>
        <b-col cols="7">
          <span
            class="filter-subcategory-item-name"
            :class="{ 'font-weight-bold': active }"
            >
            <i v-if="filtersToExport.includes(filter._id)" class="far fa-check-square ml-3" @click="exportFilter(filter._id)"></i>
            <i v-else class="far fa-square ml-3" @click="exportFilter(filter._id)"></i> 
            {{ filter.name }} {{ getCounts(filter) }}
            <!--<i
              v-if="filter._id.includes('invalid')"
              class="fas fa-exclamation-circle"
              variant="danger"
            ></i>
            <i 
              class="fas fa-info-circle"
              variant="danger" 
              v-if="filtersToExport.includes(filter._id) && checkQuery(filter.rawquery)" 
              v-b-tooltip.hover title="AND/NOT and all not TTC values in this filter will be ignored during export"
            ></i>-->
            <i 
              class="tick fas fa-tachometer-alt"
              variant="info" 
              v-if="visibleForDiscover(filter._id)"
            ></i>    
          </span>
        </b-col>
        <b-col class="text-right">
          <b-btn
            variant="link-dark"
            size="sm"
            :class="{ 'text-muted': !active }"
            @click="applyFilter(active ? null : filter)"
          >
            <i class="fa fa-filter" />
          </b-btn>
          <b-btn variant="link-dark" size="sm" @click="addToFocus(filter)">
            <i class="fa fa-eye" />
          </b-btn>
          <b-btn variant="link-dark" size="sm" @click="editFilter">
            <i class="fa fa-pencil-alt" />
          </b-btn>
          <b-btn variant="link-dark" size="sm" @click="deleteFilterConfirm">
            <i class="fa fa-trash" />
          </b-btn>
        </b-col>
      </b-row>
    </div>
  </draggable>
</template>

<script>
import draggable from "vuedraggable";
import { mapActions, mapGetters, mapState } from "vuex";
import { EventBus } from "@/eventBus";
import {
  getParentId,
  filterOutIdName,
  preFilter,
} from "../../../helpers/PrepFilters";
import DataSettings from "@/helpers/DataSettings";

export default {
  name: "FilterItem",
  components: {
    draggable,
  },
  props: {
    filter: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["filtersLookup"]),
    ...mapState({
      filterFocused: (state) => state.filter.filterFocused,
      filterDragged: (state) => state.filter.filterDragged,
      filters: (state) => state.filter.filters,
      filtersToExport: (state) => state.filter.filtersToExport,
      discoverCategories: (state) => state.setting.dataSettings.focus.lastQuery,
    }),
    active() {
      if (this.filterFocused) {
        return this.filterFocused._id === this.filter._id;
      }

      return false;
    },
  },
  methods: {
    ...mapActions([
      "deleteFilter",
      "deleteFilterCategory",
      "filterFocus",
      "setFilterDragged",
      "saveFilter",
      "addFiltersToExport",
    ]),
    exportFilter(id) {
      this.addFiltersToExport(id);
    },
    checkQuery(query){
      if(query.includes("AND") || query.includes("NOT")){
        return true;
      }
      else if(query.length > 0){
        query.forEach(q => {
          if(Array.isArray(q)){
            this.checkQuery(q)
          }
          else{
            if(q === "AND" || q === "NOT" || q._id.split("_")[0] === "TTC"){  
              return true;
            }
          }
        })
      }
      else{
        return false;
      }
    },
    applyFilter(filter) {
      if (filter) {
        if (!filter._id.includes("invalid")) {
          this.filterFocus({ filter: filter, type: "filter" });
        } else {
          let query = this.getInValidFilterQuery(filter.rawquery);
          if (query.length > 0) {
            let filterToApply = {
              _id: filter._id,
              name: filter.name,
              rawquery: query,
            };
            this.filterFocus({ filter: filterToApply, type: "Invalid" });
          } else {
            this.$toasted.show("Nothing to Apply!", {
              type: "error",
            });
          }
        }
      } else {
        this.filterFocus({ filter: null });
      }
    },
    getInValidFilterQuery(filter) {
      let query = [];
      filter.forEach((item) => {
        if (typeof item !== "string" && item._id !== "TTC_XXX") {
          query.push(item);
          query.push("OR");
        }
      });
      query.pop();
      return query;
    },
    deleteFilterConfirm() {
      this.$bvModal
        .msgBoxConfirm(
          `Are you sure you want to delete filter “${this.filter.name}”?`,
          this.$confirmOptions
        )
        .then((value) => {
          if (value) {
            this.deleteFilter({
              filter: {
                _id: this.filter._id,
              },
            }).then(() => {
              this.updateVisibilityForDel({
                filter: {
                  _id: this.filter._id,
                  subcategory: this.filter.parent_id
                },
              });
              if ("linkedfilter" in this.filter) {
                this.deleteFilter({
                  filter: {
                    _id: this.filter.linkedfilter,
                  },
                }).then(() => {
                  this.$toasted.show("Filter deleted");
                });
              } else {
                this.$toasted.show("Filter deleted");
              }
            });
          }
        });
    },
    updateVisibilityForDel(data){
      /*
      const filter = getParentId(this.filters, data.filter._id);
      const category = filter.cat;
      const subcategory = filter.subCat;
      const settings = DataSettings.getSettings("focus");
      let discoverCats = settings.lastQuery || this.filters;
      let cindex = _.findIndex(discoverCats, (f) => { return f._id === category; });
      let sindex = _.findIndex(discoverCats[cindex].children, (f) => { return f._id === subcategory; });
      let index = _.findIndex(discoverCats[cindex].children[sindex].children, (f) => { return f._id === filter.filt; });
      let newSettings = discoverCats;
      newSettings[cindex].children[sindex].children.splice(index, 1);
      DataSettings.setSettings("focus.lastQuery", newSettings);
      */
      const settings = DataSettings.getSettings("focus");
      if(this.discoverCategories.includes(data._id)){
        let newSettings = settings.lastQuery;
        const index = _.findIndex(newSettings, data._id);
        newSettings.splice(index, 1);
        DataSettings.setSettings("focus.lastQuery", newSettings);
      }
    },
    editFilter() {
      EventBus.$emit("editFilter", this.filter);
    },
    addToFocus(filter) {
      if (!filter._id.includes("invalid")) {
        this.filterFocus({ filter: filter, type: "focus" }).then(() => {
          if (this.$route.name !== "ExploreDiscover") {
            this.$router.push({ name: "ExploreDiscover" });
          }
        });
      } else {
        let query = this.getInValidFilterQuery(filter.rawquery);
        if (query.length > 0) {
          let filterToApply = {
            _id: filter._id,
            name: filter.name,
            rawquery: query,
          };
          this.filterFocus({ filter: filterToApply, type: "Invalid" }).then(
            () => {
              if (this.$route.name !== "ExploreDiscover") {
                this.$router.push({ name: "ExploreDiscover" });
              }
            }
          );
        } else {
          this.$toasted.show("Nothing to Focus!", {
            type: "error",
          });
        }
      }
    },
    draggedFilter(e) {
      this.setFilterDragged(e);
    },
    droppedFilter(e) {
      let target = getParentId(this.filters, e._id);
      let filter = {
        type: "filter",
        _id: this.filterDragged._id,
      };
      this.saveFilter({
        filter: filter,
        subcategory: { _id: target.subCat },
        category: { _id: target.cat },
      });
    },
    getCounts(filter) {
      let matched = 0;
      let unmatched = 0;
      if(filter.rawquery){
        filter.rawquery.forEach((q) => {
          if (q !== "OR") {
            q._id === "TTC_XXX" ? (unmatched += 1) : (matched += 1);
          }
        });
      }
      matched = matched;
      unmatched = unmatched;
      return "("+ matched + "/" + (matched + unmatched) + ")";
    },
    /*
    visibleForDiscover(filt){
      let response = false;
      const filterToFetch = getParentId(this.discoverCategories, filt);
      const cat = this.discoverCategories.find(f => { return f._id === filterToFetch.cat});
      const subcat = cat.children.find(f => { return f._id === filterToFetch.subCat});
      const filter = subcat.children.find(f => { return f._id === filterToFetch.filt});
      if(filter.visibility && !(filter.visibility.discover)){
        response = false
      }
      else{
        response = true
      }
      return response 
    },*/
    visibleForDiscover(filt){
      if(this.discoverCategories.length > 0){
        return !this.discoverCategories.includes(filt)
      }
      else{
        return true
      }
    }
  },
};
</script>
